module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('lms-layout', {
    attrs: {
      "actions": _vm.actions,
      "showBackButton": _vm.showBackButton,
      "backButtonClick": _vm.backButtonClick
    },
    on: {
      "toolbarClick": _vm.handleClick
    }
  }, [_c('template', {
    slot: "t-body"
  }, [_c('div', {
    staticClass: "lms-filter-content"
  }, [_vm._t("t-search")], 2), _vm._v(" "), _c('div', {
    staticClass: "m-t"
  }, [_vm._t("t-body")], 2)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31a8f75b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":true}!./src/shared/libs/ClientFramework/packages/basicElement/layout/ListLayout.vue
// module id = 918
// module chunks = 80